import _classCallCheck from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
// const debug = require('debug');
import { isUnitTest } from "@anm/shared/mode";
var level;

(function (level) {
  level[level["error"] = 0] = "error";
  level[level["warning"] = 1] = "warning";
  level[level["info"] = 2] = "info";
  level[level["debug"] = 3] = "debug";
})(level || (level = {}));

function format(fmt, args) {
  return args.reduce(function (p, c) {
    var o = typeof c === 'object' ? JSON.stringify(c) : c === null || c === void 0 ? void 0 : c.toString();
    return p.replace(/%s/, o);
  }, fmt);
} // @ts-ignore


function debug(ns, lvl) {
  var log;

  switch (true) {
    case isUnitTest && lvl !== level.error:
      log = function log() {};

      break;

    case lvl === level.warning:
      log = console.warn;
      break;

    case lvl === level.error:
      log = console.error;
      break;

    case lvl === level.info:
      log = console.info;
      break;

    default:
      log = console.debug;
      break;
  }

  return function () {
    for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
      data[_key] = arguments[_key];
    }

    if (data.length === 0) return;
    var isMsg = typeof data[0] === 'string';

    if (isMsg && (data[0].includes('%s') || data.length === 1)) {
      log("".concat(ns, " ").concat(format(data[0], [].concat(data).slice(1))));
    } else if (isMsg) {
      log.apply(void 0, ["".concat(ns, " ").concat(data[0])].concat(_toConsumableArray([].concat(data).slice(1))));
    } else {
      log.apply(void 0, [ns].concat(data));
    }
  };
}

export var Logger = function Logger(prefix) {
  _classCallCheck(this, Logger);

  this.prefix = prefix;

  _defineProperty(this, "debug", void 0);

  _defineProperty(this, "info", void 0);

  _defineProperty(this, "warn", void 0);

  _defineProperty(this, "error", void 0);

  var APP_NAME = 'wave';
  var p = prefix ? ":".concat(prefix) : '';
  this.debug = debug("[DEBUG]:".concat(APP_NAME).concat(p), level.debug);
  this.info = debug("[INFO]:".concat(APP_NAME).concat(p), level.info);
  this.warn = debug("[WARN]:".concat(APP_NAME).concat(p), level.warning);
  var error = debug("[ERROR]:".concat(APP_NAME).concat(p), level.error);

  this.error = function () {
    error.apply(void 0, arguments);
    Logger.errorHandler.apply(Logger, arguments);
  };
};

_defineProperty(Logger, "errorHandler", function () {});